import React from "react";

function DarkModeToggle({ darkMode, onToggle }) {
  return (
    <button className="btn btn-outline btn-small" onClick={onToggle}>
      {darkMode ? "Light Mode" : "Dark Mode"}
    </button>
  );
}

export default DarkModeToggle;
